import { createBrowserRouter, RouterProvider } from "react-router-dom";
import PageConfigPontoMonitoria from "./pages/ConfigPontoMonitoria";
import PageListPontosDeMonitoria from "./pages/ListPontosDeMonitoria";
import PageDashboard from "./pages/Dashboard";
import PageAlertas from "./pages/Alertas";
import PageLogin from "./pages/PageLogin";
import PageRelatorios from "./pages/Relatorios";
import PageCadastroUser from "./pages/CadastroUser";
import "./scss/global.scss";
import PageRelatoriosByLoja from "./pages/Relatorios/RelatoriosByLoja";
import PagePlantaBaixa from "./pages/PlantaBaixa";
import PageAtivarAcesso from "./pages/PageLoginAtivar";
import PageForgotPass from "./pages/PageLoginForgot";
import PrivateLayout from "./PrivateLayout";
import PageAcessoNegado from "./pages/PageAcessoNegado";
import NivelDeAcessoGuard from "./NivelDeAcessoGuard ";
import PageNaoEncontrada from "./pages/PageNaoEncontrada";
import PageDocumentacaoAVCB from "./pages/PageDocumentacaoAVCB";
import PageProperty from "./pages/PageProperty";
import PageUserConfig from "./pages/PageUserConfig";
import ConfigLoja from "./pages/ConfigLoja";
import TecnicoPage from "./pages/(tecnico)/tecnicoProcessoCriacoesPage";
import TecnicoProcessoCriacoesPage from "./pages/(tecnico)/tecnicoProcessoCriacoesPage";
import TecnicoComandosPage from "./pages/(tecnico)/tecnicoComandosPage";
import PagePainelPublico from "./pages/(ApiKey)/alertas/PageAlertasApiKey";
import PageMapaPublico from "./pages/(ApiKey)/mapa/PageMapaApiKey";
import PagePropertyApiKey from "./pages/(ApiKey)/property/PagePropertyApiKey";
import VideosInstalacao from "./pages/(ApiKey)/videosInstalacao";
import VisaoExecutiva from "./pages/(ApiKey)/VisaoExecutiva";
import PageMapaAlertas from "./pages/(ApiKey)/operacao/PageOperacao";
import PageAuditoria from "./pages/PageAuditoria";
import PagePropertyApiKeyDetalhada from "./pages/(ApiKey)/property-detalhada/PagePropertyApiKey";
import PageAgendamentoManutencao from "./pages/(manutencao)/Agendamento";
import PageManutencaoAgendada from "./pages/(manutencao)/Agendadas";

const router = createBrowserRouter([
  {
    path: "/",
    element: <PageLogin />,
  },
  {
    path: "/Ativar-acesso",
    element: <PageAtivarAcesso />,
  },
  {
    path: "/Forgot-pass",
    element: <PageForgotPass />,
  },
  {
    path: "/alertas/chave-api",
    element: <PagePainelPublico />,
  },
  {
    path: "/mapa/chave-api",
    element: <PageMapaPublico />,
  },
  {
    path: "/property/chave-api",
    element: <PagePropertyApiKey />,
  },
  {
    path: "/operacao/mapa-alertas/chave-api",
    element: <PageMapaAlertas />,
  },
  {
    path: "/videos/chave-api",
    element: <VideosInstalacao />,
  },
  {
    path: "/property-detalhada/chave-api",
    element: <PagePropertyApiKeyDetalhada />,
  },
  {
    path: "/visao-executiva/chave-api",
    element: <VisaoExecutiva />,
  },
  {
    path: "/",
    element: <PrivateLayout />,
    children: [
      {
        path: "/dashboard",
        element: <PageDashboard />,
      },
      {
        path: "/perfil",
        element: <PageUserConfig />,
      },
      {
        path: "/tecnico/processo-criacao",
        element: (
          <NivelDeAcessoGuard niveisPermitidos={[999]}>
            <TecnicoProcessoCriacoesPage />
          </NivelDeAcessoGuard>
        ),
      },
      {
        path: "/auditoria",
        element: (
          <NivelDeAcessoGuard niveisPermitidos={[999]}>
            <PageAuditoria />
          </NivelDeAcessoGuard>
        ),
      },
      {
        path: "/manutencao/agendamento",
        element: (
          <NivelDeAcessoGuard niveisPermitidos={[6, 7, 8, 9, 999]}>
            <PageAgendamentoManutencao />
          </NivelDeAcessoGuard>
        ),
      },
      {
        path: "/manutencao/agendadas",
        element: (
          <NivelDeAcessoGuard niveisPermitidos={[6, 7, 8, 9, 999]}>
            <PageManutencaoAgendada />
          </NivelDeAcessoGuard>
        ),
      },
      {
        path: "/tecnico/comandos",
        element: (
          <NivelDeAcessoGuard niveisPermitidos={[999]}>
            <TecnicoComandosPage />
          </NivelDeAcessoGuard>
        ),
      },
      {
        path: "/acesso-negado",
        element: <PageAcessoNegado />,
      },
      {
        path: "/cadastrar-usuarios",
        element: (
          <NivelDeAcessoGuard niveisPermitidos={[7, 8, 999]}>
            <PageCadastroUser />
          </NivelDeAcessoGuard>
        ),
      },
      {
        path: "/documentacao-avcb",
        element: (
          <NivelDeAcessoGuard niveisPermitidos={[3, 4, 5, 6, 7, 8, 9, 999]}>
            <PageDocumentacaoAVCB />
          </NivelDeAcessoGuard>
        ),
      },
      {
        path: "/configuracoes/loja",
        element: (
          <NivelDeAcessoGuard niveisPermitidos={[7, 8, 999]}>
            <ConfigLoja />
          </NivelDeAcessoGuard>
        ),
      },
      {
        path: "/property",
        element: (
          <NivelDeAcessoGuard niveisPermitidos={[6, 7, 8, 9, 999]}>
            <PageProperty />
          </NivelDeAcessoGuard>
        ),
      },
      {
        path: "/relatorios",
        element: <PageRelatorios />,
      },
      {
        path: "/pontos-de-monitoramento/relatorios",
        element: <PageRelatoriosByLoja />,
      },
      {
        path: "/pontos-de-monitoramento/alertas",
        element: <PageAlertas />,
        children: [
          {
            path: ":idLoja",
            element: <PageAlertas />,
          },
        ],
      },
      {
        path: "/pontos-de-monitoramento/configurar",
        element: (
          <NivelDeAcessoGuard niveisPermitidos={[6, 7, 8, 9, 999]}>
            <PageConfigPontoMonitoria />
          </NivelDeAcessoGuard>
        ),
      },
      {
        path: "/pontos-de-monitoramento/visao-detalhada",
        element: <PageListPontosDeMonitoria />,
      },
      {
        path: "/pontos-de-monitoramento/planta-baixa",
        element: <PagePlantaBaixa />,
      },
    ],
  },
  {
    path: "*",
    element: <PageNaoEncontrada />,
  },
]);

const App = () => <RouterProvider router={router} />;

export default App;
